<div id="spout-subscription-tiers">
  <!-- <div class="spout-subscription-tier">
		<h1>EARLY ADOPTER</h1>
		Includes 1 GB Storage*
		<button class="mat-focus-indicator mat-flat-button mat-button-base mat-primary ng-star-inserted"
		(click)="clickTier(0)">GET
			STARTED</button>
		<hr>
		*Terms and conditions apply to becoming an early adopter.
	</div> -->
  <div class="spout-subscription-tier">
    <h1>PERSONAL PLAN</h1>

    Includes 1 GB Storage and access to all features. <br />
    $10.00 per Month or $72.00 per Year <br />
    $3.00 per Month for an additional 1 GB of storage.<br />
    With this plan, you can invite collaborators and reviewers to your project.
    You can also share, create, remix, and export tracks. <br />
    <hr />
    <button
      class="mat-focus-indicator mat-flat-button mat-button-base mat-primary ng-star-inserted"
      (click)="clickTier(2)">
      GET STARTED
    </button>
  </div>
  <div class="spout-promo-tier">
    <h1>PROMOTIONAL PLAN</h1>
    Fully featured for 3 months at no cost to you. <br />
    Get all of the same features as a PERSONAL PLAN without any cost. <br />
    Just use the promo code <strong>"GETSPOUTNOW"</strong> at checkout.
    <hr />
    <button (click)="clickTier(1)">GET STARTED FOR FREE</button>
  </div>

  <div class="spout-subscription-tier">
    <h1>COLLABORATOR</h1>
    FREE with limited features.* <br />
    As a collaborator, you may contribute to other projects only. You must be
    invited to a project as a reviewer. Storage options are not applicable to
    this plan. File storage used by creating tracks as a collaborator count
    against the project owner's account. <br />
    <hr />
    <button
      class="mat-focus-indicator mat-flat-button mat-button-base mat-primary ng-star-inserted"
      (click)="clickTier(4)">
      GET STARTED
    </button>
    <br />
    * Collaborators cannot create projects, export audio or invite other
    collaborators. All costs for contribution are the project owner's
    responsibility.
  </div>
</div>
